import { MODEL_TYPE, RESHIPMENT_TYPE } from "../utils/enums";
export function reshipmentOrder(data) {
  return {
    products: (data.products || []).map(product=> ({ ...product, enabled: false })),
    reshipment_type: data.reshipment_type || RESHIPMENT_TYPE.marketplaceResponsibility,
    notes: data.notes || "",
    currency: data.currency,
    modelType: MODEL_TYPE.reshipmentOrder
  };
}